"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = ButtonGroup;
exports["default"] = void 0;
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _styledButtonGroup = _interopRequireDefault(require("./styled-button-group"));
var _excluded = ["className", "dataAnalyticsId", "dataAnalyticsIdSecondary", "dataTestId", "link", "secondaryLink", "buttonVariant", "secondButtonVariant"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var displayName = 'ButtonGroup';
var defaultProps = {
  className: 'fuse-button-group',
  dataAnalyticsId: undefined,
  dataAnalyticsIdSecondary: undefined,
  dataTestId: 'fuse-button-group-test-id',
  link: {
    href: undefined,
    onClick: undefined,
    text: undefined
  },
  secondaryLink: {
    href: undefined,
    onClick: undefined,
    text: undefined
  },
  buttonVariant: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary']),
  secondButtonVariant: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary'])
};
var propTypes = {
  className: _propTypes["default"].string,
  dataAnalyticsId: _propTypes["default"].string,
  dataAnalyticsIdSecondary: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  link: _propTypes["default"].shape({
    href: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    text: _propTypes["default"].string
  }),
  secondaryLink: _propTypes["default"].shape({
    href: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    text: _propTypes["default"].string
  }),
  buttonVariant: 'secondary',
  secondButtonVariant: 'tertiary'
};
function ButtonGroup(_ref) {
  var className = _ref.className,
    dataAnalyticsId = _ref.dataAnalyticsId,
    dataAnalyticsIdSecondary = _ref.dataAnalyticsIdSecondary,
    dataTestId = _ref.dataTestId,
    link = _ref.link,
    secondaryLink = _ref.secondaryLink,
    buttonVariant = _ref.buttonVariant,
    secondButtonVariant = _ref.secondButtonVariant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledButtonGroup["default"], _extends({
    className: className,
    "data-testid": dataTestId
  }, props), secondaryLink.text ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_buttons.Button, {
    className: "fuse-button-group__primary-cta",
    href: link.href,
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    variant: buttonVariant,
    "data-analyticsid": dataAnalyticsId,
    onClick: link.onClick
  }, link.text), /*#__PURE__*/_react["default"].createElement(_buttons.Button, {
    className: "fuse-button-group__secondary-cta",
    href: secondaryLink.href,
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    variant: secondButtonVariant,
    "data-analyticsid": dataAnalyticsIdSecondary,
    onClick: secondaryLink.onClick
  }, secondaryLink.text)) : /*#__PURE__*/_react["default"].createElement(_buttons.Button, {
    className: "fuse-button-group__primary-cta",
    href: link.href,
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    variant: buttonVariant,
    "data-analyticsid": dataAnalyticsId,
    onClick: link.onClick
  }, link.text));
}
ButtonGroup.displayName = displayName;
ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
var _default = exports["default"] = ButtonGroup;